module.exports = __webpack_public_path__ + "static/img/frontpage4.b557872.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/frontpage4.png
// module id = afMZ
// module chunks = 0